import { initPosthog, trackPageview } from '@plannrcrm/plannr-posthog';
import Vue from 'vue';

export default ({ app, $config, $authService}, inject) => {
  const posthog = initPosthog({
    apiKey: $config.posthogKey,
    apiHost: $config.posthogHost,
    environment: $config.environment,
  })
  if (!posthog) return

  // Identify the user once the store is populated.
  app.store.watch(
    (state) => state.user.user?.uuid,
    (userUuid) => {
      if (!userUuid) return;
      posthog.identify(userUuid)
    },
    { immediate: true }
  )

  // Register account context as super-properties when the account is set.
  app.store.watch(
    (state) => state.user.currentAccount,
    (currentAccount) => {
      if (!currentAccount) return;

      posthog.register({
        account_uuid: currentAccount.uuid,
        firm_uuid: currentAccount.firm?.uuid,
        role: currentAccount.role,
      })
    },
    { immediate: true }
  )

  // Track page views on every Nuxt route change.
  // Only capture once identified — anonymous pageviews have no value with person_profiles: 'identified_only'.
  app.router.afterEach(() => {
    Vue.nextTick(() => {
      if (!app.store.state.user.user?.uuid) return;

      trackPageview()
    })
  })

  inject('posthog', posthog)
}
